export default {
  allow: () => null,
  Orientation: {},
};



// WEBPACK FOOTER //
// ./src/@utils/orientation.web.js